<template>
    <div class="row">
        <div class="col-md-12">
            <ul style="padding-top: 20px; background-color: white">
                <li v-for="inci in incidencias" style="margin-bottom: 15px">
                    <pre>{{inci.issues}}</pre>
                </li>
            </ul>

        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        CheckboxGroup
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        created() {
            this.getIncidencias();
        },

        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        props: ['idBusiness', 'idDay'],
        data() {
            return {
                incidencias: []
            }
        },
        methods: {

            getIncidencias() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idDay: this.idDay,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "sales/getIncidenciasOfDay", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.incidencias = response.data.result;
                        }
                        else {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.result,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                        }
                        vm.loading = false;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


        }


    }
</script>

<style scoped>


</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/Widgets/Incidencias.vue